import '../stylesheets/contacts.scss'
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import Masonry from "masonry-layout";


function initMap() {
  const mapData = document.getElementById("mapData").textContent;
  const rawData = JSON.parse(mapData);
  const locations = []
  let location_icon_url = ''
  rawData.forEach(branchFunction);

  function branchFunction(data, index) {
    const branch = {}
    branch["name"] = data.name
    branch["lat"] = Number(data.latitude);
    branch["lng"] = Number(data.longitude);
    branch["type"] = data.location_type;
    branch["address"] = data.address;
    branch["phone"] = data.phone;
    locations.push(branch);
  }

  console.log(`locations: ${JSON.stringify(locations)}`);

  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 4,
    center: {lat: 39.16607055, lng: -86.52653575357857},
  });
  const infoWindow = new google.maps.InfoWindow({
    content: "",
    disableAutoPan: true,
  });
  // Create an array of alphabetical characters used to label the markers.
  const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  // Add some markers to the map.
  console.log(locations)
  const markers = locations.map((position, i) => {
    const label = labels[i % labels.length];
    const name = locations[i].name
    const address = locations[i].address
    const phone = locations[i].phone
    const title = `<div style="padding-top: 5px; padding-bottom: 5px; font-size: 16px; font-weight: bold;">${name}</div>
                   <div style="padding-bottom: 5px;">${address}</div>
                   <div>${phone}</div>`;
    if (locations[i].type === 'showroom') {
      location_icon_url = "http://maps.google.com/mapfiles/ms/icons/red.png"
    } else {
      location_icon_url = "http://maps.google.com/mapfiles/ms/micons/blue.png"
    }
    const marker = new google.maps.Marker({
      position,
      // label,
      icon: {
        url: location_icon_url
      }
    });

    // markers can only be keyboard focusable when they have click listeners
    // open info window when marker is clicked
    marker.addListener("click", () => {
      infoWindow.setContent(title);
      infoWindow.open(map, marker);
    });
    return marker;
  });

  // Add a marker clusterer to manage the markers.
  new MarkerClusterer({markers, map});
}

window.initMap = initMap;

var grid = document.querySelector('.where-to-buy');

var msnry = new Masonry(grid, {
  percentPosition: true
});

msnry.layout()
